import { gql } from 'graphql.macro';

export const fortnoxStatusTemplate = gql`
    query fortnoxStatus {
        fortnoxStatus {
            authorized
            enabled
            clientId
        }
    }
`;
